import { Navigate, useSearchParams } from "react-router-dom";

/** Keep bookmarked staff/prospect links on the same guided creation routes. */
export default function NewSite() {
  const [params] = useSearchParams();
  const placeId = params.get("placeId")?.trim();
  const name = params.get("name")?.trim();
  if (!placeId && !name) return <Navigate to="/start" replace />;
  const query = new URLSearchParams();
  if (placeId) query.set("placeId", placeId);
  if (name) query.set("business", name);
  return <Navigate to={`/start/business?${query}`} replace />;
}
